/**
 * Fit Creamery custom — fc-hide-floating-on-cart.js
 *
 * Keeps the floating CTAs from overlapping the slide-in cart. While the theme's
 * cart drawer/popup is open, add `fc-cart-open` to <html>; the floating CTA bar
 * (section-floating-cta-bar.css) and the product-bundler sticky bar
 * (product-bundler.css) each hide themselves whenever that class is present.
 *
 * Hooks the theme's own Alpine store `xMiniCart.open` — the same reactive value
 * the cart's `x-show` uses. This is the reliable signal because the cart markup
 * is ajax-injected after load on non-cart templates, so watching the DOM element
 * at DOMContentLoaded would miss it. Standalone; safe to keep across Eurus
 * theme updates.
 */
(function () {
  'use strict';

  var OPEN_CLASS = 'fc-cart-open';
  var html = document.documentElement;
  var bound = false;

  function bind() {
    if (bound) return true;
    if (!(window.Alpine && typeof Alpine.effect === 'function' && Alpine.store)) return false;
    if (!Alpine.store('xMiniCart')) return false;

    bound = true;
    // Reading `.open` inside the effect registers the reactive dependency, so
    // the class stays in sync every time the cart opens or closes.
    Alpine.effect(function () {
      html.classList.toggle(OPEN_CLASS, !!Alpine.store('xMiniCart').open);
    });
    return true;
  }

  function bindWithRetries() {
    if (bind()) return;
    var attempts = 0;
    var timer = setInterval(function () {
      // Give Alpine time to boot and register the store (~10s ceiling).
      if (bind() || ++attempts > 40) clearInterval(timer);
    }, 250);
  }

  // `alpine:initialized` fires after Alpine.start(); cover the case where it
  // already fired before this deferred script ran, too.
  document.addEventListener('alpine:initialized', bind);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindWithRetries);
  } else {
    bindWithRetries();
  }
})();
